/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { roadmapAchievementDtoSchema } from "./roadmapAchievementDtoSchema.ts";
import { roadmapMilestoneDtoSchema } from "./roadmapMilestoneDtoSchema.ts";
import { z } from "zod/v4";

export const roadmapSectionDtoSchema = z.object({
  get milestones() {
    return z.array(roadmapMilestoneDtoSchema).optional();
  },
  get pastAchievements() {
    return z.array(roadmapAchievementDtoSchema).optional();
  },
});
